import React from 'react';
import { useNoIndex } from '@/hooks/useNoIndex';

/**
 * Die Originaldatei wird unverändert als eigenständiges HTML-Dokument
 * (public/warum-ich.html) in einem iframe ausgeliefert, damit ihr eigenes
 * CSS/JS nicht mit dem Tailwind der Hauptseite kollidiert.
 */
const WarumIch = () => {
  useNoIndex();

  return (
    <iframe
      src="/warum-ich.html"
      title="Warum Paweł Czechowski einstellen"
      className="fixed inset-0 w-full h-full border-0"
    />
  );
};

export default WarumIch;
